module.exports = __WEBPACK_EXTERNAL_MODULE_1__;


//////////////////
// WEBPACK FOOTER
// external "Vue"
// module id = 1
// module chunks = 0 1 2 3 4 5 6 7 8 9